export { LogoIcon as Logo } from "@behaviour-lab/blab-component-library"
